var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.previewVisible,"footer":null},on:{"cancel":function($event){_vm.previewVisible = false}}},[_c('div',{staticStyle:{"padding":"24px 0"}},[(_vm.previewImage)?_c('img',{staticStyle:{"width":"100%"},attrs:{"alt":"","src":_vm.previewImage}}):_c('div',{staticClass:"tips"},[_vm._v("暂无图片")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }